import { useLocation, useNavigate } from "react-router-dom"
import Footer from "../../../components/molecules/footer/Footer"
import Header from "../../../components/molecules/header/Header"
import { useState } from "react";

const DatosAdicionales = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [datosAdicionales] = useState(state?.detalle)
    

    return (<>
        <Header />
        <div className="container row" role="main" data-landmark-index="4">
            <div className="d-flex justify-content-between">
                {/*<Titulo
                clases={"subSubTituloSolicitud p-2 fw-bold"}
                tipo={"tituloCard noBg"}
                titulo={`${state?.dacto}`}
                ></Titulo>*/}
                <h2 className="tituloAccesibilidadMini">{state?.dacto}</h2>
            </div>
            <div className="datosAd col-10 mx-auto my-4">
                {!datosAdicionales ? (
                    <p className="text-danger">Error al cargar los datos adicionales para mostrar.</p>
                ) : (<>
                    { datosAdicionales?.map((item, index) => (
                        <div key={index} className="row d-flex align-items-center">
                            <div className="nombre col-12 col-md-3 col-lg-3 letraBold">{item.NOMBRE}: </div>
                            <div className="descripcionDA col-12 col-md-9 col-lg-9"><p className="mb-0 text-break">{item.VALOR} {item.DESCRIPCION !== null && item.DESCRIPCION !== "" ? (<>{item.DESCRIPCION}</>) : null}</p></div>
                            <div className="col-12"><hr className="my-2" /></div>
                        </div>
                    ))}
                </>)
                }
            </div>
            <div className="gridBotones my-3">
                <button
                    id="volver"
                    className="btnRed rounded btnCancelarDocumentacion"
                    type="button"
                    onClick={() => navigate("/misActosAdmin")}
                >
                    <i className="fa-solid fa-rotate-left"></i> Volver
                </button>
            </div>
        </div>
        <Footer />
    </>)
}

export default DatosAdicionales